// src/config/cacheConfig.js
export const TABLE_CACHE_EXPIRY_MS = 5 * 60 * 1000;
